import { css } from 'lit';
export default css `
  :host {
    display: inline-block;
    --private-avatar-size: 40px;
  }
  .avatar {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    position: relative;
    width: var(--private-avatar-size);
    height: var(--private-avatar-size);
    background-color: var(--private-avatar-bg-color, --amityeko-color-gray-5);
    font-size: calc(var(--private-avatar-size) * 0.5);
    font-weight: normal;
    color: var(--amityeko-color-gray-4);
    user-select: none;
    vertical-align: middle;
  }

  .avatar--circle,
  .avatar--circle .avatar-image {
    border-radius: 50%;
  }

  .avatar--rounded,
  .avatar--rounded .avatar-image {
    border-radius: var(--amityeko-radius-small);
  }

  .avatar-initials {
    line-height: 1;
    text-transform: uppercase;
  }

  .avatar-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;
//# sourceMappingURL=styles.js.map